/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const fullscreen = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m1 15 4.978-4.978M1 11.89V15h3.111m5.911-9.022L15 1m-3.111 0H15v3.111M1 1l4.978 4.978M4.11 1H1v3.111m9.022 5.911L15 15m0-3.111V15h-3.111"
    />
  </svg>
)
export default fullscreen
